import { graphql } from '@teachino/shared-infrastructure';
import { folderFragment } from './folder.fragment';
import { topicListItemFragment } from './topic-list-item';

export const libraryFolderQuery = graphql(
  `
    query LibraryFolder($id: String!) {
      libraryFolder(libraryFolderIdInput: { id: $id }) {
        ...Folder
      }
      searchContent(
        contentSearchInput: { libraryFolderId: $id, searchType: TOPIC }
      ) {
        ... on BaseModel {
          id
          __typename
        }
        ... on TopicInstance {
          position
        }
        ... on Folder {
          id
          ...TopicListItem
        }
      }
    }
  `,
  [folderFragment, topicListItemFragment],
);
